// skills/mining/miningData.js
// Mining rocks, ores, and configuration

export const ROCKS = {
    // Level 1
    PYRESTONE: {
        id: 'pyrestone',
        name: 'Pyrestone Rock',
        level: 1,
        xp: 17.5,
        baseTime: 3000, // 3 seconds base mining time
        drops: [
            { itemId: 'pyrestone_ore', weight: 1, quantity: 1 }
        ],
        color: '#b87333',
        sprite: { sheet: 'assets/icons/mining/pyrestone_rock.png', x: 0, y: 0, width: 64, height: 64 }
    },
    PALE_SHARD: {
        id: 'pale_shard',
        name: 'Pale Shard Rock',
        level: 10,
        xp: 17.5,
        baseTime: 3000,
        drops: [
            { itemId: 'pale_shard_ore', weight: 1, quantity: 1 }
        ],
        color: '#c0c0c0',
        sprite: { sheet: 'assets/icons/mining/paleshard_rock.png', x: 0, y: 0, width: 64, height: 64 }
    },
    // Level 15
    BLACKIRON: {
        id: 'blackiron',
        name: 'Blackiron Rock',
        level: 15,
        xp: 35,
        baseTime: 4000,
        drops: [
            { itemId: 'blackiron_ore', weight: 1, quantity: 1 }
        ],
        color: '#696969',
        sprite: { sheet: 'assets/icons/mining/blackiron_rock.png', x: 0, y: 0, width: 64, height: 64 }
    },
    // Level 20 - Gem vein (sapphire/emerald/ruby)
    GLIMMERING_VEIN: {
        id: 'glimmering_vein',
        name: 'Glimmering Vein',
        level: 20,
        xp: 46,
        baseTime: 5000,
        drops: [
            { itemId: 'sapphire', weight: 60, quantity: 1 },
            { itemId: 'emerald', weight: 30, quantity: 1 },
            { itemId: 'ruby', weight: 10, quantity: 1 }
        ],
        color: '#0f52ba',
        sprite: { sheet: 'assets/icons/mining/glimmering_vein.png', x: 0, y: 0, width: 64, height: 64 }
    },
    // Level 30
    DEEPCOAL: {
        id: 'deepcoal',
        name: 'Deepcoal Rock',
        level: 30,
        xp: 50,
        baseTime: 5000,
        drops: [
            { itemId: 'deepcoal', weight: 1, quantity: 1 }
        ],
        color: '#1a1a1a',
        sprite: { sheet: 'assets/icons/mining/deepcoal_rock.png', x: 0, y: 0, width: 64, height: 64 }
    },
    // Level 40
    GOLD: {
        id: 'gold',
        name: 'Gold Rock',
        level: 40,
        xp: 65,
        baseTime: 6000,
        drops: [
            { itemId: 'gold_ore', weight: 1, quantity: 1 }
        ],
        color: '#ffd700',
        sprite: { sheet: 'assets/icons/mining/gold_rock.png', x: 0, y: 0, width: 64, height: 64 }
    },
    LUSTROUS_VEIN: {
        id: 'lustrous_vein',
        name: 'Lustrous Vein',
        level: 40,
        xp: 65,
        baseTime: 6000,
        drops: [
            { itemId: 'sapphire', weight: 30, quantity: 1 },
            { itemId: 'emerald', weight: 35, quantity: 1 },
            { itemId: 'ruby', weight: 25, quantity: 1 },
            { itemId: 'diamond', weight: 10, quantity: 1 }
        ],
        color: '#50c878',
        sprite: { sheet: 'assets/icons/mining/lustrous_vein.png', x: 0, y: 0, width: 64, height: 64 }
    },
    // Level 55
    SKYIRON: {
        id: 'skyiron',
        name: 'Skyiron Rock',
        level: 55,
        xp: 80,
        baseTime: 7000,
        drops: [
            { itemId: 'skyiron_ore', weight: 1, quantity: 1 }
        ],
        color: '#4169e1',
        sprite: { sheet: 'assets/icons/mining/skyiron_rock.png', x: 0, y: 0, width: 64, height: 64 }
    },
    // Level 60 - Gem vein (emerald/ruby/diamond/astryx_stone)
    RADIANT_VEIN: {
        id: 'radiant_vein',
        name: 'Radiant Vein',
        level: 60,
        xp: 80,
        baseTime: 7000,
        drops: [
            { itemId: 'emerald', weight: 25, quantity: 1 },
            { itemId: 'ruby', weight: 30, quantity: 1 },
            { itemId: 'diamond', weight: 30, quantity: 1 },
            { itemId: 'astryx_stone', weight: 15, quantity: 1 }
        ],
        color: '#e0115f',
        sprite: { sheet: 'assets/icons/mining/radiant_vein.png', x: 0, y: 0, width: 64, height: 64 }
    },
    // Level 70
    VERDANT_CORE: {
        id: 'verdant_core',
        name: 'Verdant Core Rock',
        level: 70,
        xp: 95,
        baseTime: 8000,
        drops: [
            { itemId: 'verdant_core_ore', weight: 1, quantity: 1 }
        ],
        color: '#228b22',
        sprite: { sheet: 'assets/icons/mining/verdantcore_rock.png', x: 0, y: 0, width: 64, height: 64 }
    },
    // Level 80 - Gem vein (ruby/diamond/astryx_stone/onyx)
    PRISMATIC_VEIN: {
        id: 'prismatic_vein',
        name: 'Prismatic Vein',
        level: 80,
        xp: 100,
        baseTime: 8000,
        drops: [
            { itemId: 'ruby', weight: 20, quantity: 1 },
            { itemId: 'diamond', weight: 35, quantity: 1 },
            { itemId: 'astryx_stone', weight: 30, quantity: 1 },
            { itemId: 'onyx', weight: 15, quantity: 1 }
        ],
        color: '#9932cc',
        sprite: { sheet: 'assets/icons/mining/prismatic_vein.png', x: 0, y: 0, width: 64, height: 64 }
    },
    // Level 85
    VOIDSTEEL: {
        id: 'voidsteel',
        name: 'Voidsteel Rock',
        level: 85,
        xp: 125,
        baseTime: 10000,
        drops: [
            { itemId: 'voidsteel_ore', weight: 1, quantity: 1 }
        ],
        color: '#00ced1',
        sprite: { sheet: 'assets/icons/mining/voidsteel_rock.png', x: 0, y: 0, width: 64, height: 64 }
    }
};

// Mining tools/pickaxes
export const PICKAXES = {
    PYRESTONE: {
        id: 'pyrestone_pickaxe',
        name: 'Pyrestone Pickaxe',
        level: 1,
        speedMultiplier: 1.0,
        price: 0 // Starting tool
    },
    BLACKIRON: {
        id: 'blackiron_pickaxe',
        name: 'Blackiron Pickaxe',
        level: 10,
        speedMultiplier: 1.2,
        price: 1000
    },
    PALE_SHARD: {
        id: 'pale_shard_pickaxe',
        name: 'Pale Shard Pickaxe',
        level: 20,
        speedMultiplier: 1.4,
        price: 5000
    },
    SKYIRON: {
        id: 'skyiron_pickaxe',
        name: 'Skyiron Pickaxe',
        level: 40,
        speedMultiplier: 1.6,
        price: 25000
    },
    VERDANT: {
        id: 'verdant_pickaxe',
        name: 'Verdant Pickaxe',
        level: 60,
        speedMultiplier: 1.8,
        price: 100000
    },
    VOIDSTEEL: {
        id: 'voidsteel_pickaxe',
        name: 'Voidsteel Pickaxe',
        level: 80,
        speedMultiplier: 2.0,
        price: 250000
    }
};

export default {
    ROCKS,
    PICKAXES
};